import { css } from "@emotion/core";
import {
  color,
  fontTypes,
  fontSizes,
  fontWeight,
} from "../../constants/commons";

export const containerStyles = css`
  display: flex;
  justify-content: center;
  max-width: 100em;
  margin: auto;
  .responsive-landing-header-left {
    color: ${color.lighterGray};
    font-family: ${fontTypes.black};
    font-size: ${fontSizes.xxlg};
  }

  .partner-img-style {
    border-radius: 0.8em;
  }
  .partner-header {
    background: linear-gradient(
      -153.43494882292202deg,
      ${color.whitishGray} 0%,
      ${color.whitishGray} 100%
    );
  }

  .footer-background {
    background: linear-gradient(
      -90deg,
      ${color.whitishGray} 0%,
      ${color.white} 100%
    );
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-partner-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xxlg};
      font-weight: ${fontWeight.light};
      text-align: center;
    }
    .responsive-partner-short-heading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.md};
      font-weight: ${fontWeight.medium};
      text-align: center;
      padding: 0 1.25em;
    }
    .responsive-margin-landingpage {
      padding: 1em;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .responsive-partner-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.miniLarge};
      font-weight: ${fontWeight.light};
      text-align: center;
    }
    .responsive-partner-short-heading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.lg};
      font-weight: ${fontWeight.medium};
      text-align: center;
    }
    .responsive-margin-landingpage {
      padding: 1em;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .responsive-partner-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.tabletFooter};
      font-weight: ${fontWeight.light};
      text-align: center;
    }
    .responsive-partner-short-heading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xlg};
      font-weight: ${fontWeight.medium};
      text-align: center;
    }
    .responsive-margin-landingpage {
      padding: 1.5em 2.5em;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .responsive-partner-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.tabletFooter};
      font-weight: ${fontWeight.light};
      text-align: center;
    }
    .responsive-partner-short-heading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xlg};
      font-weight: ${fontWeight.medium};
      text-align: center;
    }
    .responsive-margin-landingpage {
      padding: 1.5em 6em;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .responsive-partner-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.tabletFooter};
      font-weight: ${fontWeight.light};
      text-align: center;
    }
    .responsive-partner-short-heading {
      color: ${color.lightishGray};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xlg};
      font-weight: ${fontWeight.medium};
      text-align: center;
    }
    .responsive-margin-landingpage {
      padding: 1.5em 10em;
    }
  }
`;

export const partnerSpeaksStyles = (isMobileView?: boolean) => css`
  ${!isMobileView &&
  `/* Extra small devices (portrait phones, less than 576px) */
    @media (max-width: 575.98px) {
      .header-container{
        padding: 0 1em;
      }
      .carousel-data-container{
        padding: 0 1em;
      }
    }
    /* Small devices (landscape phones, 576px and up) */
    @media (min-width: 576px) and (max-width: 767.98px) {
      .header-container{
        padding: 0 1em;
      }
      .carousel-data-container{
        padding: 0 1em;
      }
    }
    /* Medium devices (tablets, 768px and up) */
    @media (min-width: 768px) and (max-width: 991.98px) {
      .header-container{
        padding: 0 2.5em;
      }
      .carousel-data-container{
        padding: 0 2.5em;
      }
    }
    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) and (max-width: 1199.98px) {
      .header-container{
        padding: 0 6em;
      }
      .carousel-data-container{
        padding: 0 6em;
      }
    }
    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {
      .header-container{
        padding: 0 10em;
      }
      .carousel-data-container{
        padding: 0 10em;
      }
    }

    .card-container {
      max-width: none !important;
    }

    video {
      max-width: 28.75em !important;
      /* Medium devices (tablets, 768px and up) */
      @media (min-width: 768px) and (max-width: 991.98px) {
        max-width: 20em !important;
      }
    }`}
`;
